<template>
    <div class="animated fadeIn" id="faturamento-competencia">
        <div class="card card-default">
            <div class="card-header">
                <div class="card-header"><i class="fa fa-money"></i> Faturamento Funcional</div>
            </div>
            <div class="card-body">
                <div class="input-group mb-3 align-items-center" style="gap: 10px;">
                    <span class="input-group-text d-flex align-items-center justify-content-center"
                        style="width: 100px; height: 40px;">
                        Competência
                    </span>
                    <date-picker input-class="form-control datepicker-custom-height" v-model="competencia" lang="pt-br"
                        format="MM/YYYY" type="month" @change="updateCompetencia"></date-picker>
                    <span class="input-group-text d-flex align-items-center justify-content-center" id="profissional"
                        style="width: 100px; height: 40px;">
                        Profissional
                    </span>
                    <!-- Dropdown multiselect -->
                    <b-dropdown :text="dropdownLabel" class="align-middle custom-dropdown"
                        toggle-class="custom-dropdown-input" no-close-on-click no-auto-close="outside">
                        <b-dropdown-item-button @click="selecionarTodosProfissionais" style="min-width: 250px;">
                            <i class="fa fa-check-square mr-2"></i> Selecionar todos
                        </b-dropdown-item-button>
                        <b-dropdown-item-button @click="limparProfissionaisSelecionados" style="min-width: 250px;">
                            <i class="fa fa-times mr-2"></i> Limpar seleção
                        </b-dropdown-item-button>
                        <b-dropdown-divider></b-dropdown-divider>
                        <div v-for="(prof, idx) in profissionais"
                            :key="`${checkboxRenderKey}-prof-${prof && prof.id ? prof.id : idx}`" class="px-3 py-1">
                            <b-form-checkbox v-model="selectedProfissionais" :value="prof">
                                {{ prof.nome }}
                            </b-form-checkbox>
                        </div>
                    </b-dropdown>
                    <button class="btn btn-primary" style="height: 40px;" @click="filtrar"
                        :disabled="isLoading || !competencia">
                        <i v-if="isLoading" class="fa fa-spinner fa-spin"></i>
                        <span v-else><i class="icon-magnifier"></i> Filtrar</span>
                    </button>
                </div>
                <!-- Tabela de resultados -->
                <div v-if="faturamento.length" class="table-responsive mt-4">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <span class="font-weight-bold">
                            Total de Horas: <span>{{ totalHorasRealizadas }}</span>
                        </span>
                        <button
                            class="btn btn-primary"
                            style="height: 40px; min-width: 90px;"
                            @click="copyFaturamento"
                        >
                            <i class="fa fa-copy"></i> Copiar
                        </button>
                    </div>
                    <table id="table-faturamento" class="table table-bordered table-striped table-sm">
                        <thead>
                            <tr>
                                <th v-for="(col, idx) in tableColumns" :key="idx">{{ col }}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(row, idx) in faturamento" :key="idx">
                                <td v-for="col in tableColumns" :key="col">{{ row[col] }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div v-else class="mt-4" v-if="tabelaCarregada && faturamento.length === 0">
                    <span>Nenhum registro encontrado.</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Uteis from "@/mixins/utils.js";
import DatePicker from "vue2-datepicker";

export default {
    name: 'FaturamentoFuncional',
    mixins: [Uteis],
    components: {
        DatePicker,
    },
    data() {
        return {
            competencia: null,
            periodoInicio: null,
            periodoFinal: null,
            selectProfissionais: 0,
            profissionais: [],
            selectedProfissionais: [],
            checkboxRenderKey: 0,
            isLoading: false,
            faturamento: [],
            tabelaCarregada: false,
        }
    },
    async mounted() {
        await this.getProfissionais();
    },
    computed: {
        dropdownLabel() {
            const total = this.selectedProfissionais.length;
            return total === 0
                ? "Selecionar profissionais"
                : `${total} profissional${total > 1 ? "is" : ""} selecionado${total > 1 ? "s" : ""}`;
        },
        tableColumns() {
            if (this.faturamento.length > 0) {
                return Object.keys(this.faturamento[0]);
            }
            return [];
        },
        totalHorasRealizadas() {
            // Soma a coluna "Horas Realizadas" de todos os registros, tratando string com vírgula e valores inválidos, e exibe com 2 casas decimais (arredondamento para cima)
            const total = this.faturamento.reduce((total, row) => {
                let val = row["Horas Realizadas"];
                if (typeof val === "string") {
                    val = val.replace(',', '.').replace(/[^0-9.]/g, '');
                }
                val = parseFloat(val);
                return total + (isNaN(val) ? 0 : val);
            }, 0);
            return (Math.ceil((total + Number.EPSILON) * 100) / 100).toFixed(2);
        }
    },
    methods: {
        async getProfissionais() {
            const data = 947;
            try {
                const response = await this.$http.get("/faturamento/analistas", {
                    params: { idUsuarioGitlab: data }
                });
                this.profissionais = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error('Erro ao buscar profissionais:', error);
                this.$toasted.error('Erro ao buscar profissionais.');
                this.profissionais = [];
            }
        },

        selecionarTodosProfissionais() {
            this.selectedProfissionais = this.profissionais.slice();
            this.checkboxRenderKey++;
        },

        limparProfissionaisSelecionados() {
            this.selectedProfissionais = [];
            this.checkboxRenderKey++;
        },

        updateCompetencia(date) {
            if (date) {
                const competenciaDate = new Date(date);

                const inicio = new Date(competenciaDate);
                inicio.setMonth(inicio.getMonth() - 1);
                inicio.setDate(26);
                this.periodoInicio = inicio;

                const fim = new Date(competenciaDate);
                fim.setDate(25);
                this.periodoFinal = fim;
            } else {
                this.periodoInicio = null;
                this.periodoFinal = null;
            }
        },

        async filtrar() {
            const formatDate = (date) => {
                if (!date) return null;
                const d = new Date(date);
                const year = d.getFullYear();
                const month = String(d.getMonth() + 1).padStart(2, '0');
                const day = String(d.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            };
            const dto = {
                competencia: formatDate(this.competencia),
                idUsuarioGitlab: this.selectedProfissionais.map(p => p.usuario_gitlab_id)
            };
            try {
                this.isLoading = true;
                this.tabelaCarregada = false;
                const response = await this.$http.get(
                    "/faturamento/faturamento-funcionais",
                    { params: dto }
                );
                this.faturamento = Array.isArray(response.data) ? response.data : [];
                this.tabelaCarregada = true;
            } catch (e) {
                this.faturamento = [];
                this.tabelaCarregada = true;
                this.$toasted.error('Erro ao buscar faturamento.');
            } finally {
                this.isLoading = false;
            }
        },
        copyFaturamento() {
            // Função igual ao copyElementToClipboard do HorasCompetencia.vue
            window.getSelection().removeAllRanges();
            const element = document.getElementById('table-faturamento');
            if (!element) return;
            const range = document.createRange();
            range.selectNode(element);
            window.getSelection().addRange(range);
            document.execCommand('copy');
            window.getSelection().removeAllRanges();
        },
    }
}
</script>

<style>
.input-group-text {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 12px;
    font-size: 14px;
    height: 40px;
}

/* DatePicker customizado para altura igual ao span */
.datepicker-custom {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
    font-size: 14px;
}

/* Altura aumentada para o date-picker */
.datepicker-custom-height {
    height: 40px !important;
    min-height: 40px !important;
    max-height: 40px !important;
    font-size: 14px;
}

/* Customização do dropdown */
.custom-dropdown .dropdown-toggle {
    display: inline-block;
    /* garante alinhamento */
    vertical-align: middle;
    background-color: transparent !important;
    border: 1px solid #dde2e7 !important;
    color: #6c757d !important;
    border-radius: 4px;
    min-width: 280px;
    width: 280px;
    height: 40px;
    line-height: 1.5;
}


.custom-dropdown .dropdown-toggle:hover,
.custom-dropdown .dropdown-toggle:focus,
.custom-dropdown .dropdown-toggle:active {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
    box-shadow: none !important;
}

.custom-dropdown.show .dropdown-toggle {
    background-color: transparent !important;
    border-color: #6c757d !important;
    color: #6c757d !important;
}

.custom-dropdown .dropdown-menu {
    border: 1px solid #6c757d;
    border-radius: 4px;
    min-width: 280px;
    width: 280px;
}

.custom-dropdown .dropdown-item {
    min-width: 250px;
    width: 250px;
}
</style>
